// extracted by mini-css-extract-plugin
export default {"UndoNotification":"UndoNotification_UndoNotification__+-r6X","UndoButtonWrapper":"UndoNotification_UndoButtonWrapper__Vzr1w"};